import React, { useEffect, useState } from "react";

const TAG_PALETTE = [
  { bg: "#DBEAFE", text: "#1D4ED8" }, // blue
  { bg: "#DCFCE7", text: "#15803D" }, // green
  { bg: "#FEF3C7", text: "#B45309" }, // amber
  { bg: "#FCE7F3", text: "#BE185D" }, // pink
  { bg: "#EDE9FE", text: "#6D28D9" }, // violet
  { bg: "#FEE2E2", text: "#B91C1C" }, // red
  { bg: "#CFFAFE", text: "#0E7490" }, // cyan
];

export function tagColor(tag) {
  let hash = 0;
  for (let i = 0; i < tag.length; i++) hash = (hash * 31 + tag.charCodeAt(i)) >>> 0;
  return TAG_PALETTE[hash % TAG_PALETTE.length];
}

// Compact live SLA countdown for hot leads. 24h from created_at.
export function SLABadge({ createdAt, className = "" }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 30_000);
    return () => clearInterval(t);
  }, []);

  const deadline = new Date(createdAt).getTime() + 24 * 60 * 60 * 1000;
  const diff = deadline - now;
  const overdue = diff <= 0;
  const abs = Math.abs(diff);
  const h = Math.floor(abs / 3_600_000);
  const m = Math.floor((abs % 3_600_000) / 60_000);
  const label = overdue ? `SLA overdue ${h}h ${m}m` : `SLA ${h}h ${m}m left`;

  return (
    <span
      title={overdue ? "24h SLA breached" : "24h response SLA"}
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider ${className} ${
        overdue
          ? "bg-red-100 text-red-800 border border-red-300 animate-pulse"
          : h < 4
          ? "bg-orange-50 text-orange-700 border border-orange-200"
          : "bg-emerald-50 text-emerald-700 border border-emerald-200"
      }`}
    >
      {label}
    </span>
  );
}

export function initials(name) {
  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0].toUpperCase())
    .join("");
}

export function avatarColor(name) {
  const c = tagColor(name);
  return { bg: c.bg, text: c.text };
}
